"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "meduno": {
    "ca6b3212": [{
      "hkey": "b8078130",
      "slug": "meduno",
      "name": "Meduno",
      "primary": true,
      "skipSearch": false
    }],
    "avon": [{
      "hkey": "b8078130",
      "slug": "meduno",
      "name": "Meduno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e298cf16": [{
      "hkey": "b8078130",
      "slug": "meduno",
      "name": "Meduno",
      "primary": true,
      "skipSearch": false
    }],
    "cilia": [{
      "hkey": "b8078130",
      "slug": "meduno",
      "name": "Meduno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "616ac69f": [{
      "hkey": "b8078130",
      "slug": "meduno",
      "name": "Meduno",
      "primary": true,
      "skipSearch": false
    }],
    "costa": [{
      "hkey": "b8078130",
      "slug": "meduno",
      "name": "Meduno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "51e62b82": [{
      "hkey": "b8078130",
      "slug": "meduno",
      "name": "Meduno",
      "primary": true,
      "skipSearch": false
    }],
    "mizzeri": [{
      "hkey": "b8078130",
      "slug": "meduno",
      "name": "Meduno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a87d795f": [{
      "hkey": "9c5383b4",
      "slug": "romaniz",
      "name": "Romaniz",
      "primary": true,
      "skipSearch": false
    }],
    "romanis": [{
      "hkey": "9c5383b4",
      "slug": "romaniz",
      "name": "Romaniz",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "4a61624b": [{
      "hkey": "b8078130",
      "slug": "meduno",
      "name": "Meduno",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino": [{
      "hkey": "b8078130",
      "slug": "meduno",
      "name": "Meduno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e266b19e": [{
      "hkey": "b8078130",
      "slug": "meduno",
      "name": "Meduno",
      "primary": true,
      "skipSearch": false
    }],
    "sottomonte": [{
      "hkey": "b8078130",
      "slug": "meduno",
      "name": "Meduno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f1668d1a": [{
      "hkey": "b8078130",
      "slug": "meduno",
      "name": "Meduno",
      "primary": true,
      "skipSearch": false
    }],
    "valle": [{
      "hkey": "b8078130",
      "slug": "meduno",
      "name": "Meduno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;